import React, { Component } from "react";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import { Row, Col, Image, FormControl, InputGroup } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import userblock1 from "../../../assets/images/userblock1.svg";
import { ReactComponent as Briefcase } from "../../../assets/images/Briefcase.svg";
// import "../../../App.scss"
import Loader from "../../common/Loader";
import delivaApiService from "../../../common/services/apiService";
import {
  getLocalStorage,
  getStatusBackgroundColor,
  getStatusClassName,
  range,
} from "../../../common/helpers/Utils";
import CONSTANTS from "../../../common/helpers/Constants";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DownloadIcon from "../../../assets/images/DownloadIcon.svg";

class DeliveryAgentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      delivery_agent_list: [],
      pageno: 1,
      records: 10,
      totalCount: "",
      sortBy: "",
      sortOrder: "desc",
      keyword: "",
      search: "",
      showInviteVendors: false,
      blockedDueToCancellationLimit: "",
      searchByLocation: "",
    };
  }

  handleInviteVendors = (id, status) => {
    this.setState({
      showInviteVendors: !this.state.showInviteVendors,
      blockId: id,
      blockedStatus: status,
    });
  };

  componentDidMount() {
    this.getDeliveryAgent(
      this.state.pageno,
      this.state.records,
      this.state.sortBy,
      this.state.sortOrder,
    );
  }

  getDeliveryAgent = (pageno, records, sortBy, sortOrder) => {
    this.setState({
      delivery_agent_list: [],
      showLoader: true,
      pageno: pageno,
      records: records,
      sortBy: sortBy,
      sortOrder: sortOrder,
    });
    delivaApiService("deliveryAgentList", {
      pageNumber: pageno,
      records: records == 0 ? CONSTANTS.SHOWRECORDS.NOOFRECORDS : records,
      blockedDueToCancellationLimit: this.state.blockedDueToCancellationLimit,
      sortBy: sortBy,
      sortOrder: sortOrder,
      searchByProfile: this.state.search,
      searchByLocation: this.state.searchByLocation,
      logInUserId: getLocalStorage("id"),
    })
      .then((response) => {
        this.setState({ showLoader: false });
        if (response.data.status == 200) {
          this.setState({
            delivery_agent_list: response?.data?.resourceData.dAList,
            totalCount: response?.data?.resourceData.totalCount,
          });
          this.getPager(response?.data?.resourceData?.totalCount);
        } else {
          this.setState({
            delivery_agent_list: [],
            totalCount: 0,
          });
          this.setLoader(false);
        }
      })
      .catch((error) => {
        this.setState({
          showLoader: false,
        });
      });
  };

  //manage page counts
  getPager(total) {
    this.setState(
      {
        records:
          this.state.records == 0
            ? CONSTANTS.SHOWRECORDS.NOOFRECORDS
            : this.state.records,
      },
      () => {
        let startPage = this.state.startPage;
        let endPage = this.state.endPage;
        let totalPage = Math.ceil(total / this.state.records);
        let pageno = this.state.pageno;

        if (totalPage <= 5) {
          startPage = 1;
          endPage = totalPage;
        } else {
          if (pageno <= 3) {
            startPage = 1;
            endPage = 5;
          } else if (pageno + 1 >= totalPage) {
            startPage = totalPage - 4;
            endPage = totalPage;
          } else {
            startPage = pageno - 2;
            endPage = pageno + 2;
          }
        }
        let startIndex = (pageno - 1) * this.state.records;
        let endIndex = Math.min(
          startIndex + this.state.records - 1,
          totalPage - 1,
        );

        // create an array of pages to ng-repeat in the pager control
        let pageArray;
        if (startPage == endPage) {
          pageArray = [1];
        } else {
          pageArray = range(startPage, endPage);
        }
        this.setState({
          // records: this.state.records,
          totalPage: totalPage,
          startPage: startPage,
          endPage: endPage,
          startIndex: startIndex,
          endIndex: endIndex,
          pageArray: pageArray,
        });
      },
    );
  }

  // change page

  onChangePage(page) {
    if (page == this.state.pageno) {
    } else {
      this.getDeliveryAgent(
        page,
        this.state.records,
        this.state.sortBy,
        this.state.sortOrder,
      );
    }
  }

  //change data per page
  onChangeItemPerPage(e) {
    this.setState({ records: e.target.value });
  }

  onEnterPerPage(e) {
    if (e.key === "Enter") {
      const val = e.target.value;
      if (val && val > 0) {
        this.getDeliveryAgent(1, val);
      }
    }
  }

  //block and unblock api call
  blockUnblock() {
    this.setState({ showLoader: true });
    let data = {
      userId: this.state.blockId,
    };
    delivaApiService("blockUnblockCustomer", data)
      .then((response) => {
        this.handleInviteVendors("");
        this.setState({ showLoader: false });
        this.getDeliveryAgent(this.state.pageno, this.state.records);
      })
      .catch((error) => {
        this.setState({
          showLoader: false,
        });
      });
  }

  deliveryAgentProfile = (item) => {
    // if (!item.blocked) {
    this.props.history.push("/deliveryPartnerProfile", { item });
    // }
  };

  handleChangeTab(val) {
    this.setState({ pageno: 1 });
    if (val == "now") {
      this.setState({ blockedDueToCancellationLimit: "" }, () => {
        this.getDeliveryAgent(this.state.pageno, this.state.records);
      });
    } else {
      this.setState({ blockedDueToCancellationLimit: "yes" }, () => {
        this.getDeliveryAgent(this.state.pageno, this.state.records);
      });
    }
  }

  handleChangeInput = (e) => {
    const { name, value } = e.target;
    let trimmedValue = value.replace(/\s+/g, " ").trimStart();

    this.setState({ [name]: trimmedValue }, () => {
      if (
        this.state.search.trim() === "" &&
        this.state.searchByLocation.trim() === "" &&
        trimmedValue === "" &&
        value?.[0] !== " "
      ) {
        this.getDeliveryAgent(this.state.pageno, this.state.records);
      }
    });
  };

  clearSearch = (field) => {
    this.setState({ [field]: "" }, () => {
      this.getDeliveryAgent(this.state.pageno, this.state.records);
    });
  };

  handleEnter = (e) => {
    if (e.key == "Enter") {
      this.getDeliveryAgent(this.state.pageno, this.state.records);
    }
  };

  handleSearch() {
    const { search, searchByLocation } = this.state;

    if (search.trim() !== "" || searchByLocation.trim() !== "") {
      this.getDeliveryAgent(this.state.pageno, this.state.records);
    }
  }

  sortDeliveryAgent(val) {
    const newSortOrder = this.state.sortOrder === "desc" ? "asc" : "desc";
    this.setState({ sortOrder: newSortOrder }, () => {
      this.getDeliveryAgent(
        this.state.pageno,
        this.state.records,
        val,
        newSortOrder,
      );
    });
  }

  // {console.log("this.state.delivery_agent_list",this.state.delivery_agent_list)}

  fetchAllDeliveryPartnersForExport = () => {
    this.setState({ showLoader: true });

    delivaApiService(
      "exportDownloadSheet",
      {
        blockedDueToCancellationLimit: this.state.blockedDueToCancellationLimit,

        sortBy: this.state.sortBy || "agentCode",
        sortOrder: this.state.sortOrder || "",
        searchByProfile: this.state.search,
        searchByLocation: this.state.searchByLocation,
        logInUserId: getLocalStorage("id"),
        roleId: getLocalStorage("roleId"),
      },
      { responseType: "blob" },
    )
      .then((response) => {
        this.setState({ showLoader: false });

        const blob = new Blob([response.data], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, "delivery_partners.csv");
      })
      .catch(() => {
        this.setState({ showLoader: false });
        alert("Failed to fetch export data.");
      });
  };

  exportData = (type, data) => {
    const exportList = data || [];

    const exportData = exportList.map((item) => ({
      "Partner Code": `#${item.userId}`,
      Name: item.name || "-",
      "Phone Number": item.mobile ? `+${item.countryCode} ${item.mobile}` : "-",
      Email: item.email || "-",
      "KYC Status": item.kycStatus || "-",
      "Banking Status": item.bankingStatus || "-",
      Address: item?.address || "-",
      "Joining Date": item.joiningDate
        ? moment(item.joiningDate).utc().format("DD MMM YYYY")
        : "--",
      "Last Login": item.lastLogin || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    //  Set exact range so no extra rows appear
    worksheet["!ref"] = XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: exportData.length, c: Object.keys(exportData[0]).length - 1 },
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Delivery Partners");

    const fileType = type === "csv" ? "csv" : "xlsx";
    const excelBuffer = XLSX.write(workbook, {
      bookType: fileType,
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `delivery_partners.${fileType}`);
  };

  render() {
    const { delivery_agent_list } = this.state;
    return (
      <div className="page__wrapper h-100">
        <Modal
          show={this.state.showInviteVendors}
          onHide={() => this.handleInviteVendors("", "")}
          centered
        >
          {/* <Modal.Header closeButton className="border-0">
                    
                    </Modal.Header> */}
          <Modal.Body>
            <div className="modal-content-wrap text-center">
              <Image src={userblock1} className="img-fluid user-block-img" />
              <h4 className="tertiary-color  mt-3">Are You Sure?</h4>
              <p className="color-grey">
                Are you sure you want to{" "}
                {this.state.blockedStatus == true ? "unblock" : "block"} this
                user?{" "}
                {/* {this.state.blockedStatus == false
                  ? "You can not view this profile once blocked."
                  : ""} */}
              </p>

              <button
                className="cancel-btn mr-3"
                onClick={() => this.handleInviteVendors("")}
              >
                Cancel
              </button>
              <button onClick={() => this.blockUnblock()} className="b1-btn">
                {this.state.blockedStatus == true ? "Unblock" : "Block"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Header {...this.props} />

        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper">
                  <Row noGutters className="mb-3 align-items-center">
                    <Col className="">
                      <h3 className="font-weight-normal fs-24 mb-0 line-ht color-33">
                        Delivery Partners{" "}
                        <span className="color-grey">
                          ({this.state.totalCount})
                        </span>
                      </h3>
                    </Col>
                    <Col md="auto" xl="9">
                      <InputGroup
                        className="mb-2 search-wrap d-flex"
                        style={{ minWidth: "100%" }}
                      >
                        <InputGroup.Prepend className="search-inner-wrap">
                          <FormControl
                            type="text"
                            placeholder="Search by Address"
                            name="searchByLocation"
                            value={this.state.searchByLocation || ""}
                            onChange={(e) => this.handleChangeInput(e)}
                            onKeyDown={this.handleEnter.bind(this)}
                          />
                          <span className="icon-search"></span>
                          <a
                            href="#"
                            className="icon-close1 pointer"
                            onClick={() => this.clearSearch("searchByLocation")}
                          ></a>
                        </InputGroup.Prepend>
                        <InputGroup className="search-inner-wrap">
                          <FormControl
                            type="text"
                            placeholder="Search by Partner ID/Contact/Name/Business/Email"
                            name="search"
                            value={this.state.search}
                            onChange={(e) => this.handleChangeInput(e)}
                            onKeyDown={this.handleEnter.bind(this)}
                          />
                          <span className="icon-search"></span>
                          <a
                            href="#"
                            className="icon-close1 pointer"
                            onClick={() => this.clearSearch("search")}
                          ></a>
                        </InputGroup>
                        <button
                          className="find-btn"
                          onClick={() => this.handleSearch()}
                          disabled={
                            !this.state.search && !this.state.searchByLocation
                          }
                        >
                          Find
                        </button>
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12} lg={12} className="d-flex">
                      <button
                        className={
                          this.state.blockedDueToCancellationLimit == ""
                            ? "bor-da-btn mr-3"
                            : "bor-btn grey-btn mr-3"
                        }
                        onClick={() => {
                          this.handleChangeTab("now");
                        }}
                      >
                        Delivering Now
                      </button>
                      <button
                        // className="bor-btn grey-btn"
                        className={
                          this.state.blockedDueToCancellationLimit == "yes"
                            ? "bor-da-btn"
                            : "bor-btn grey-btn"
                        }
                        onClick={() => {
                          this.handleChangeTab("blocked");
                        }}
                      >
                        Blocked Due To Crossing Cancellation Limit
                      </button>
                      <button
                        className="btnDefault btnOutline minw-150 ml-auto d-flex fw-normal"
                        onClick={this.fetchAllDeliveryPartnersForExport}
                      >
                        <span className="icon-download mr-2">
                          <img
                            src={DownloadIcon}
                            className="img-fluid user-block-img"
                          />
                        </span>
                        Download Sheet
                      </button>
                    </Col>
                  </Row>
                  <div className="row">
                    <div className="col-sm-12">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>
                              Partner{" "}
                              <span className="d-block text-nowrap">
                                Code{" "}
                                <a
                                  href="#"
                                  onClick={() =>
                                    this.sortDeliveryAgent("agentCode")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </span>
                            </th>
                            <th>
                              Name &{" "}
                              <span className="d-block text-nowrap">
                                Business{" "}
                                <a
                                  href="#"
                                  onClick={() => this.sortDeliveryAgent("name")}
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </span>
                            </th>

                            <th>
                              <span className="d-block text-nowrap">
                                Contact & Email{" "}
                                {/* <a
                                  href="#"
                                  onClick={() =>
                                    this.sortDeliveryAgent('phoneNumber')
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a> */}
                              </span>
                            </th>
                            {/* <th >
                              <span className="d-block text-nowrap">
                                Email{' '}
                                <a
                                  href="#"
                                  onClick={() =>
                                    this.sortDeliveryAgent('email')
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </span>
                            </th> */}
                            <th>
                              Address{" "}
                              {/* <a
                                href="#"
                                onClick={() =>
                                  this.sortDeliveryAgent("address")
                                }
                                className="icon-up-and-down color-light-grey"
                              ></a> */}
                            </th>
                            <th>
                              <span className="d-block text-nowrap pr-2">
                                Kyc Status{" "}
                                {/* <a
                                  onClick={() =>
                                    this.sortDeliveryAgent("kycStatus")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a> */}
                              </span>
                            </th>
                            <th>
                              <span className="d-block text-nowrap">
                                Banking Status{" "}
                                {/* <a
                                  onClick={() =>
                                    this.sortDeliveryAgent("bankingStatus")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a> */}
                              </span>
                            </th>

                            <th>
                              <span className="d-block text-nowrap">
                                Joining Date{" "}
                                <a
                                  onClick={() =>
                                    this.sortDeliveryAgent("createdAt")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </span>
                            </th>
                            <th>
                              <span className="d-block text-nowrap">
                                Last Login{" "}
                                <a
                                  onClick={() =>
                                    this.sortDeliveryAgent("lastLogin")
                                  }
                                  className="icon-up-and-down color-light-grey"
                                ></a>
                              </span>
                            </th>

                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody className="ttl-order-table">
                          {!this.state.delivery_agent_list.length ? (
                            <tr>
                              <td colSpan={12} style={{ textAlign: "center" }}>
                                No Records Available
                              </td>
                            </tr>
                          ) : (
                            this.state.delivery_agent_list.map((item, i) => {
                              return (
                                <tr key={item.userId}>
                                  {/* Use a unique key, in this case, item.userId */}
                                  <td>#{item.userId}</td>
                                  <td className="text-capitalize">
                                    {item.name}
                                    {item.businessName && (
                                      <span className="mb-0 ml-0 d-block">
                                        <Briefcase
                                          width="20"
                                          height="20"
                                          className="mr-1 mb-1"
                                        />
                                        {`${item.businessName}`}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    +{item.countryCode} {item.mobile}
                                    <span className="mb-0 d-block">
                                      {item.email}
                                    </span>
                                  </td>
                                  {/* <td style={{ width: '250px' }}>
                                    {item.email}
                                  </td> */}
                                  <td>{item?.address}</td>
                                  <td
                                    className={getStatusClassName(
                                      item?.kycStatus,
                                    )}
                                  >
                                    <div className="flex-active">
                                      <span
                                        className="ab-dot"
                                        style={getStatusBackgroundColor(
                                          item?.kycStatus,
                                        )}
                                      ></span>

                                      {item?.kycStatus}
                                    </div>
                                  </td>

                                  <td
                                    className={getStatusClassName(
                                      item?.bankingStatus,
                                    )}
                                  >
                                    <div className="flex-active">
                                      <span
                                        className="ab-dot"
                                        style={getStatusBackgroundColor(
                                          item?.bankingStatus,
                                        )}
                                      ></span>
                                      {item?.bankingStatus}
                                    </div>
                                  </td>

                                  <td>
                                    {moment(item.joiningDate)
                                      .utc()
                                      .format("DD MMM YYYY")}
                                  </td>

                                  <td>
                                    <div className="flex-active d-block">
                                      {item?.lastLogin
                                        ? moment(item.lastLogin).format(
                                            "DD MMM YYYY | h:mm A",
                                          )
                                        : "-"}
                                    </div>
                                  </td>

                                  <td className="views-icos">
                                    {/* Block/Unblock toggle */}
                                    {!item.blocked ? (
                                      <a
                                        className="pointer"
                                        onClick={() =>
                                          this.deliveryAgentProfile(item)
                                        }
                                      >
                                        <span
                                          title="View"
                                          className="text-nowrap"
                                        >
                                          <i className="icon-eye"></i>
                                          {/* View */}
                                        </span>
                                      </a>
                                    ) : (
                                      <a
                                        className="pointer"
                                        onClick={() =>
                                          this.deliveryAgentProfile(item)
                                        }
                                      >
                                        <span
                                          title="View"
                                          className="text-nowrap"
                                        >
                                          <i className="icon-eye"></i>
                                          {/* View */}
                                        </span>
                                      </a>
                                    )}
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    {!item.blocked ? (
                                      <a
                                        className="pointer"
                                        onClick={() =>
                                          this.handleInviteVendors(
                                            item.userId,
                                            item.blocked,
                                          )
                                        }
                                      >
                                        <span
                                          title="Block"
                                          className="text-nowrap"
                                        >
                                          <i className="icon-password"></i>
                                          &nbsp;
                                          {/* Block */}
                                        </span>
                                      </a>
                                    ) : (
                                      <a
                                        className="pointer"
                                        onClick={() =>
                                          this.handleInviteVendors(
                                            item.userId,
                                            item.blocked,
                                          )
                                        }
                                      >
                                        <span
                                          title="Unblock"
                                          className="text-nowrap"
                                        >
                                          <i className="icon-unblockicon"></i>
                                          &nbsp;
                                          {/* Unblock */}
                                        </span>
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </Table>
                      {this.state.delivery_agent_list.length ? (
                        <nav aria-label="Page navigation">
                          <ul className="pagination pg-blue deliva-pagination justify-content-end">
                            <li className="page-item">
                              <button
                                className="page-link rotate-180 control-btn"
                                aria-label="Previous"
                                onClick={() =>
                                  this.onChangePage(this.state.pageno - 1)
                                }
                                disabled={
                                  this.state.pageno == 1 ||
                                  this.state.totalPage == 0
                                }
                              >
                                <span className="icon-next"></span>
                                <span
                                  //className="prevNext"
                                  className={`sr-only ${
                                    this.state.pageno == 1 ||
                                    this.state.totalPage == 0
                                      ? ""
                                      : "active"
                                  }`}
                                >
                                  Previous
                                </span>
                              </button>
                            </li>

                            {this.state.totalPage > 0 &&
                              this.state.pageArray.map((page, ind) => {
                                return (
                                  <li className="page-item" key={Math.random()}>
                                    {/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                    <a
                                      className={`page-link ${
                                        this.state.pageno == page
                                          ? "active"
                                          : ""
                                      }`}
                                      onClick={() => this.onChangePage(page)}
                                    >
                                      {page}
                                    </a>
                                  </li>
                                );
                              })}

                            <li className="page-item">
                              <button
                                className="page-link control-btn"
                                aria-label="Next"
                                onClick={() =>
                                  this.onChangePage(this.state.pageno + 1)
                                }
                                disabled={
                                  this.state.pageno == this.state.totalPage ||
                                  this.state.totalPage == 0
                                }
                              >
                                <span className="icon-next"></span>
                                <span
                                  className={`sr-only ${
                                    this.state.pageno == this.state.totalPage ||
                                    this.state.totalPage == 0
                                      ? ""
                                      : "active"
                                  }`}
                                >
                                  Next
                                </span>
                              </button>
                            </li>

                            <li className="page-value">
                              Enter Per Page{" "}
                              <input
                                type="text"
                                placeholder={CONSTANTS.SHOWRECORDS.NOOFRECORDS}
                                name="records"
                                value={this.state.records}
                                onChange={(e) => this.onChangeItemPerPage(e)}
                                onKeyDown={(e) => this.onEnterPerPage(e)}
                              />
                            </li>
                          </ul>
                        </nav>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <Footer {...this.props} />
            </Col>
          </Row>
        </div>
        <Loader showLoader={this.state.showLoader} />
      </div>
    );
  }
}
export default DeliveryAgentTable;
